// CSS Modules - component class name prefix: TextTeaser__

<template>
  <div
    ref="textTeaserContainerRef"
    :class="[$style.container, { TextTeaser__static: this.isStatic }]"
  >
    <h2 :class="$style.head">{{ head }}</h2>
    <div
      :class="[
        $style.text,
        { TextTeaser__shadow: !this.isInnerContainerSmaller },
        { TextTeaser__hideShadow: this.isContainerFullWidth }
      ]"
      id="textTeaserText_"
      ref="textTeaserTextRef"
    >
      <div id="textTeaserTextInner_" ref="textTeaserTextInnerRef">
        {{ text }}
      </div>
      <span
        @click="setContainerFullWidth"
        v-if="!isInnerContainerSmaller || this.isContainerFullWidth"
        :class="$style.more"
        v-html="isContainerFullWidth ? ' weniger' : ' mehr'"
      >
      </span>
    </div>
    <div :class="$style.docLinkContainer">
      <a
        v-for="(link, index) in links"
        :class="$style.docLink"
        href="#"
        :key="index"
        >{{ link }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextTeaser",
  props: {
    head: String,
    text: String,
    links: {
      type: Array,
      default: () => []
    },
    isStatic: Boolean
  },
  data: () => {
    return {
      isMobile: false,
      isInnerContainerSmaller: true,
      isContainerFullWidth: false,
      tout: null,
      textTeaserTextId: "textTeaserText_",
      textTeaserTextInnerId: "textTeaserTextInner_"
    };
  },
  mounted() {
    window.addEventListener("resize", this.resizeHandler, false);
    this.checkScreenSize();
    this.setOverflowElements();
  },
  updated() {
    if (!this.tout) {
      this.resizeHandler();
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler, false);
  },
  methods: {
    checkScreenSize() {
      window.innerWidth < 780
        ? (this.isMobile = true)
        : (this.isMobile = false);
    },
    resizeHandler() {
      this.tout = setTimeout(() => {
        this.checkScreenSize();
        this.setOverflowElements();
        if (this.isContainerFullWidth) {
          this.setContainerSize();
        }
        clearTimeout(this.tout);
      }, 500);
    },
    setOverflowElements() {
      // const textRef = this.$refs.textTeaserTextRef;
      // const textInnerRef = this.$refs.textTeaserTextInnerRef;
      const textRef = document.getElementById(this.textTeaserTextId);
      const textInnerRef = document.getElementById(this.textTeaserTextInnerId);
      if (textRef && textInnerRef) {
        this.isInnerContainerSmaller =
          textInnerRef.clientHeight < textRef.clientHeight;
      }
    },
    findColumnsElement() {
      let $containerParent = this.$refs.textTeaserContainerRef.parentElement;
      for (let i = 0; i < 5; i++) {
        if ($containerParent.className.indexOf("columns") >= 0) {
          return $containerParent;
        } else {
          $containerParent = $containerParent.parentElement;
        }
      }
      return null;
    },
    setContainerFullWidth() {
      this.isContainerFullWidth = !this.isContainerFullWidth;
      this.setContainerSize();
    },
    setContainerSize() {
      const columnsContainer = this.findColumnsElement();
      // const textRef = this.$refs.textTeaserTextRef;
      const textRef = document.getElementById(this.textTeaserTextId);
      const textInnerRef = document.getElementById(this.textTeaserTextInnerId);
      //const textInnerRef = this.$refs.textTeaserTextInnerRef;
      const containerRef = this.$refs.textTeaserContainerRef;
      if (columnsContainer && this.isContainerFullWidth) {
        if (!this.isMobile) {
          // take columnsContainer.clientWidth + 1 because on some devices columns clientWidth is not the full length
          containerRef.style.width = `${columnsContainer.offsetWidth + 1}px`;
        }
        if (
          textRef &&
          textInnerRef &&
          textInnerRef.clientHeight > textRef.clientHeight
        ) {
          textRef.style.maxHeight = "none";
          if (!this.isMobile) {
            containerRef.style.height = `${textInnerRef.clientHeight +
              (containerRef.clientHeight - textRef.clientHeight)}px`;
          } else {
            containerRef.style.height = `${textInnerRef.clientHeight +
              (containerRef.clientHeight - textRef.clientHeight + 30)}px`;
          }
        }
      } else {
        containerRef.style.width = null;
        containerRef.style.height = null;
        textRef.style.maxHeight = null;
      }
    }
  }
};
</script>

<style module lang="scss">
@import "./TextTeaser.scss";
</style>
